import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { PROMO_BANNER_GIFT_CTA_FLAG_NAME } from '../constants'

export const useTrackExperimentViewed = (isEligible: boolean) => {
  useEffect(() => {
    if (!isEligible) return

    trackExperimentViewed(PROMO_BANNER_GIFT_CTA_FLAG_NAME)
  }, [isEligible])
}
